/* eslint-disable */
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import moment from 'moment';

const propTypes = {
    freelancerData: PropTypes.object.isRequired,
    editionEnabled: PropTypes.bool.isRequired,
    onSave: PropTypes.func.isRequired,
    stats: PropTypes.object.isRequired,
};

class FreelancerOtherDetails extends Component {
    getTodaysDate() {
        return moment()
            .set({ hour: 4, minute: 0, second: 0, millisecond: 0 })
            .toISOString();
    }

    render() {
        const { freelancerData, stats, isAgent } = this.props;

        return (
            <div className="freelancer-details-section">
                <div className="freelancer-details-section__header">
                    <div className="freelancer-details-section__title">
                        Stats
                    </div>
                </div>
                <div className="freelancer-details-section__content">
                    <table className="table-default">
                        {isAgent ? (
                            <tbody>
                                <tr>
                                    <td className="table-default__cell--text-blue">
                                        No. completed shifts
                                    </td>
                                    <td>
                                        <Link
                                            to={{
                                                pathname:
                                                    '/operations/bookings',
                                                search: `search=${freelancerData.reference_number}&bookings_status=AV&ordering=-date&getall=1`,
                                            }}
                                        >
                                            {freelancerData.completed_jobs}
                                        </Link>
                                    </td>
                                </tr>
                                <tr>
                                    <td className="table-default__cell--text-blue">
                                        No. upcoming shifts
                                    </td>
                                    <td>
                                        <Link
                                            to={{
                                                pathname:
                                                    '/operations/bookings',
                                                search: `search=${
                                                    freelancerData.reference_number
                                                }&after=${this.getTodaysDate()}`,
                                            }}
                                        >
                                            {stats.content
                                                ? stats.content
                                                      .total_future_bookings
                                                : '0'}
                                        </Link>
                                    </td>
                                </tr>
                                <tr>
                                    <td className="table-default__cell--text-blue">
                                        No. cancelled shifts
                                    </td>
                                    <td>
                                        <Link
                                            to={{
                                                pathname:
                                                    '/operations/bookings',
                                                search: `search=${freelancerData.reference_number}&bookings_status=FC&ordering=-date&getall=1`,
                                            }}
                                        >
                                            {stats.content
                                                ? stats.content
                                                      .total_freelancer_cancelled_bookings
                                                : '0'}
                                        </Link>
                                    </td>
                                </tr>
                                <tr>
                                    <td className="table-default__cell--text-blue">
                                        No. five-stars feedbacks
                                    </td>
                                    <td>
                                        {stats.content
                                            ? stats.content
                                                  .total_five_star_feedbacks
                                            : '0'}
                                    </td>
                                </tr>
                                <tr>
                                    <td className="table-default__cell--text-blue">
                                        Date Published
                                    </td>
                                    <td>
                                        {freelancerData.date_published
                                            ? moment(
                                                  freelancerData.date_published,
                                              ).format('Do MMMM YYYY')
                                            : 'N/A'}
                                    </td>
                                </tr>
                                <tr>
                                    <td className="table-default__cell--text-blue">
                                        Last application date
                                    </td>
                                    <td>
                                        {moment(
                                            freelancerData.last_applied,
                                        ).format('Do MMMM YYYY')}
                                    </td>
                                </tr>
                                <tr>
                                    <td className="table-default__cell--text-blue">
                                        Active Since
                                    </td>
                                    <td>
                                        {moment(
                                            freelancerData.date_joined,
                                        ).format('Do MMMM YYYY')}
                                    </td>
                                </tr>
                                {/* <tr>
                                <td className="table-default__cell--text-blue">Average number of completed shifts per month</td>
                                <td>- N/A -</td>
                            </tr> */}
                            </tbody>
                        ) : (
                            <tbody>
                                <tr>
                                    <td className="table-default__cell--text-blue">
                                        No. five-stars feedbacks
                                    </td>
                                    <td>
                                        {stats.content
                                            ? stats.content
                                                  .total_five_star_feedbacks
                                            : '0'}
                                    </td>
                                </tr>
                                <tr>
                                    <td className="table-default__cell--text-blue">
                                        No. completed shifts
                                    </td>
                                    <td>{freelancerData.completed_jobs}</td>
                                </tr>
                                <tr>
                                    <td className="table-default__cell--text-blue">
                                        No. upcoming shifts
                                    </td>
                                    <td>
                                        {stats.content
                                            ? stats.content
                                                  .total_future_bookings
                                            : '0'}
                                    </td>
                                </tr>
                            </tbody>
                        )}
                    </table>
                </div>
            </div>
        );
    }
}

FreelancerOtherDetails.propTypes = propTypes;

export default FreelancerOtherDetails;
